import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import HomePage from "./HomePage";
import AppIntroPage from "./AppIntroPage";
import DeveloperPage from "./DeveloperPage";
import AdminLogin from "./AdminLogin";
import AdminArticles from "./AdminArticles";
import AppPrivacyPage from "./AppPrivacyPage";
function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/app" element={<AppIntroPage />} />
        <Route path="/developer" element={<DeveloperPage />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin/articles" element={<AdminArticles />} />
        <Route path="/app/privacy" element={<AppPrivacyPage />} />
      </Routes>
    </Router>
  );
}

export default App;
